import React from 'react';
import { Layout } from '../../components/layout/Layout';
import { PageHeader } from '../../components/layout/PageHeader';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { GraduationCap, Users } from 'lucide-react';

export const AnalyticsPage: React.FC = () => {
  return (
    <Layout>
      <div className="flex-1 w-full">
        <div className="mx-auto w-full max-w-4xl px-6 py-8 space-y-6">
          <PageHeader title="Analytics & Reports" subtitle="Monitor student progress and performance" />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Student Analytics Card */}
            <Card className="hover:shadow-lg transition-shadow cursor-pointer">
              <CardHeader>
                <CardTitle className="flex items-center gap-3 text-lg">
                  <GraduationCap className="w-6 h-6 text-blue-600" />
                  Student Analytics
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
                  View AI tutor usage, speaking performance, and progress metrics for your students.
                </p>
                <div className="text-xs text-gray-500">
                  Coming soon: Student roster and individual analytics
                </div>
              </CardContent>
            </Card>

            {/* Teacher Analytics Card */}
            <Card className="hover:shadow-lg transition-shadow cursor-pointer">
              <CardHeader>
                <CardTitle className="flex items-center gap-3 text-lg">
                  <Users className="w-6 h-6 text-green-600" />
                  Teacher Analytics
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
                  Monitor your teaching effectiveness and student engagement patterns.
                </p>
                <div className="text-xs text-gray-500">
                  Coming soon: Teaching analytics and insights
                </div>
              </CardContent>
            </Card>
          </div>

          <Card>
            <CardContent className="pt-6">
              <div className="text-center py-8">
                <GraduationCap className="w-16 h-16 text-gray-400 mx-auto mb-4" />
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                  Analytics Coming Soon
                </h3>
                <p className="text-gray-600 dark:text-gray-400 max-w-md mx-auto">
                  We're building comprehensive analytics to help you track student progress and teaching effectiveness.
                  Student AI tutor analytics are available to students in their tutor interface.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </Layout>
  );
};

export default AnalyticsPage;

